import React from 'react';
import {FormGroup, Label, Input} from 'reactstrap';

interface BoxEditorProps {
    size?: number;
    width?: number | null;
    height?: number | null;
    depth?: number | null;
    onChange: (size: number) => void;
    onWidthChange: (width: number | null) => void;
    onHeightChange: (height: number | null) => void;
    onDepthChange: (depth: number | null) => void;
}

// Width, height and depth each fall back to the size when they're empty.
const BoxEditor: React.FC<BoxEditorProps> = ({
    size,
    width,
    height,
    depth,
    onChange,
    onWidthChange,
    onHeightChange,
    onDepthChange
}) => {
    const handleSizeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = parseFloat(e.target.value);
        onChange(isNaN(value) ? 0 : value);
    };

    const sideField = (
        label: string,
        value: number | null | undefined,
        onSideChange: (value: number | null) => void
    ) => (
        <FormGroup style={{flex: 1}}>
            <Label>{label}</Label>
            <Input
                type="number"
                step="0.1"
                value={value ?? ''}
                placeholder={String(size ?? 1)}
                onChange={e => {
                    const value = parseFloat(e.target.value);
                    onSideChange(isNaN(value) ? null : value);
                }}
            />
        </FormGroup>
    );

    return (
        <>
            <FormGroup>
                <Label>Size:</Label>
                <Input
                    type="number"
                    step="0.1"
                    value={size ?? ''}
                    onChange={handleSizeChange}
                />
            </FormGroup>
            <div className="d-flex gap-2">
                {sideField('Width', width, onWidthChange)}
                {sideField('Height', height, onHeightChange)}
                {sideField('Depth', depth, onDepthChange)}
            </div>
        </>
    );
};

export default BoxEditor;
